// This file is AUTOGENERATED, do not edit it manually!!!

export const inlineEdit = {
    ActivityChildrenActualHours_Text: 'Registros de tempo para todas as subatividades:',
    ActivityChildrenEstimatedHours_Text: 'Horas estimadas para todas as subatividades:',
    ActivityOwnBudget_Text: 'Orçamento para a atividade:',
    ActivityOwnEstimatedHours_Text: 'Horas estimadas para a atividade:',
    ActivitySubactivitiesBudget_Text: 'Orçamento para todas as subatividades:',
    ActualCompletion_Text: 'Conclusão real',
    ActualHours_Total_Text: 'Horas gastas reais, total:',
    AddTimeEntry_Text: 'Adicionar entrada de tempo',
    AddUser_Text: 'Convidar Usuário',
    AddWeeklyTime_Text: 'Adicionar tempo semanal',
    Apply: 'Aplicar',
    Assignees_Text: 'Designados',
    BudgetedCost_Text: 'Orçamento Total do Projeto:',
    BudgetPadding_Text: 'Contingência:',
    BudgetTotal_Text: 'Orçamento, total:',
    Cancel: 'Cancelar',
    Close: 'Fechar',
    Combobox_Add: 'Adicionar ',
    Combobox_KeepTyping: 'Continue digitando...',
    Combobox_MultipleSelectDefault: 'Selecione algumas opções',
    Combobox_NoResults: 'Sem resultados',
    Combobox_NoResultsMatch: 'Nenhum resultado encontrado',
    Cost_Text: 'Cobrança:',
    CreateAndSelect: 'Criar e selecionar',
    CustomerLabel: 'Cliente',
    day_template: '1#{0} dia#{0} dias',
    Duration_Text: 'Duração',
    EditProjectMembers_Title: 'Membros do Projeto',
    EditTaskAssignees_Title: 'Designados',
    End_Text: 'Fim',
    EndDate_Text: 'Data de término',
    EstimatedHours_Text: 'Horas estimadas:',
    EstimatedHours_Total_Text: 'Horas estimadas, total:',
    field_for_all_activities: 'Este campo é apenas para atividades <b style=\"white-space: nowrap;\">({0} tarefas, {1} questões, {2} solicitações)</b>',
    field_for_issues: 'Este campo é apenas para <b style=\"white-space: nowrap;\">{0} questões</b>',
    field_for_projects: 'Este campo é apenas para <b style=\"white-space: nowrap;\">{0} projetos</b>',
    field_for_requests: 'Este campo é apenas para <b style=\"white-space: nowrap;\">{0} solicitações</b>',
    field_for_tasks: 'Este campo é apenas para <b style=\"white-space: nowrap;\">{0} tarefas</b>',
    Hours_Short_Text: 'h',
    HoursLeftLabel: 'Horas restantes:',
    InternalCost_Text: 'Custo Real:',
    NonProjectMembers_Text: 'Membros não pertencentes ao projeto',
    Not_Space_Members: 'Não são membros do espaço',
    Overloaded_Text: 'Sobrecarregado',
    OwnActualHours_Text: 'Registros de tempo para a atividade:',
    PlannedExpenses_Text: 'Despesas Planejadas:',
    PortfolioLabel: 'Portfólio',
    Progress: 'Progresso',
    ProgressCalculatedBySubActivities: 'Com base no progresso das subatividades',
    ProjectChildrenActualHours_Text: 'Registros de tempo para as atividades:',
    ProjectChildrenEstimatedHours_Text: 'Horas estimadas para todas as atividades:',
    ProjectMembers_Text: 'Membros do Projeto',
    ProjectOwnBudget_Text: 'Orçamento de Mão de Obra para o projeto:',
    ProjectOwnEstimatedHours_Text: 'Horas estimadas para o projeto:',
    ProjectSubactivitiesBudget_Text: 'Orçamento para todas as atividades:',
    Space_Members: 'Membros do Espaço',
    Start_Text: 'Início',
    StartDate_Text: 'Data de início',
    Teams_Text: 'Equipes',
    Timelogs_In_Past: 'Editar o tempo de uma atividade que ocorreu há mais de {0} no passado não é recomendado. Tem certeza de que deseja prosseguir?',
    Timelogs_In_Past_Short: 'Editar o tempo de uma atividade que ocorreu há mais de {0} no passado não é recomendado',
    TimeLogs_Warning_Project_Closed: 'Adicionar tempo a um projeto fechado não é recomendado. Tem certeza de que deseja prosseguir com a adição de tempo ao projeto fechado?',
    TimeLogs_Warning_Project_Closed_Short: 'Adicionar tempo a um projeto fechado não é recomendado',
    TimeLogs_Warning_Task_Closed: 'Adicionar tempo a uma atividade fechada não é recomendado. Tem certeza de que deseja prosseguir com a adição de tempo a esta atividade fechada?',
    TimeLogs_Warning_Task_Closed_Short: 'Adicionar tempo a uma atividade fechada não é recomendado',
    Tooltip_Dependent_Template: '{0} está vinculado a uma atividade dependente e não pode ser alterado.',
    Tooltip_HasChildren_Template: '{0} é calculado com base nas subatividades e não pode ser alterado.',
    Tooltip_ItemCompleted: 'Não pode ser editado, pois está vinculado a uma atividade/projeto fechado.',
    Tooltip_Open_Details: 'Por favor, abra os detalhes para editar este campo',
    Untitled: 'Sem Título',
    Validation_ActComplDateRange: 'A data de conclusão real não está dentro do intervalo esperado.',
    Validation_DateMandatory: 'A data é um campo obrigatório.',
    Validation_DurationMandatory: 'A duração é um campo obrigatório.',
    Validation_EndDateRange: 'A data de término não está dentro do intervalo esperado.',
    Validation_FieldMandatory: 'Este é um campo obrigatório.',
    Validation_FromDateRange: 'A partir da data não está dentro do intervalo esperado.',
    Validation_Interger: 'O valor deve ser um número inteiro.',
    Validation_InvalidDate: 'A data deve estar no formato \'{0}\'.',
    Validation_NumberRange: 'O valor deve estar entre {0} e {1}.',
    Validation_Range: 'O valor não está dentro do intervalo esperado.',
    Validation_StartDateRange: 'A data de início não está dentro do intervalo esperado.',
    Validation_ToDateRange: 'Até a data não está dentro do intervalo esperado.',
    Validation_WeekendOrVacation: 'O valor não deve cair em um fim de semana ou feriado.',
    Warning_UnassigneFromAllTasksInProject: 'Os membros removidos serão desvinculados de todas as atividades neste projeto.',
    Warning_UnassignFromAllTasksInProject_Single: 'O membro removido será desvinculado de todas as atividades neste projeto.',
};
